import React from 'react'
import { BarChart, Bar, ResponsiveContainer, XAxis, LabelList } from 'recharts'

import colors from 'src/styles/theme/colors'

export interface DataPoint {
  xAxis: string
  yAxis: number
}

export type BarGraphProps = {
  data?: DataPoint[]
  legendText?: string
  width: number
  height: number
}

type HistoryGraphProps = {
  data?: DataPoint[]
  valueFormatter?: (value: number) => any
  maxHeight?: number
}

export const HistoryGraph = ({
  data,
  maxHeight = 300,
  valueFormatter = v => v
}: HistoryGraphProps) => {
  return (
    <ResponsiveContainer
      width='99%'
      height='100%'
      minHeight={300}
      maxHeight={maxHeight}
    >
      <BarChart
        data={data}
        margin={{
          top: 20
        }}
      >
        <Bar barSize={30} dataKey='yAxis' fill={colors.mostlyGreen}>
          <LabelList
            dataKey='yAxis'
            formatter={valueFormatter}
            position='top'
            className='text-[12px] md:text-[14px] text-mostlyGreen font-semibold'
          />
        </Bar>
        <XAxis
          dataKey='xAxis'
          className='text-[14px] sm:text-base font-semibold text-mostlyGreen'
        />
      </BarChart>
    </ResponsiveContainer>
  )
}
